import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import TipTapEditor from "../../../TipTap/TipTapEditor";
import AgentConfigSection from "../AgentConfigSection";
import AgentAvatarField from "../AgentAvatarField";

export default function InstructionsTab({
  agentId,
  isSystemAgent,
  name,
  avatarDisplayUrl,
  canEditAvatar,
  uploadingAvatar,
  avatarError,
  isCreateMode,
  onSelectAvatarFile,
  onRemoveAvatar,
  avatarAccept,
  setName,
  description,
  setDescription,
  systemPrompt,
  setSystemPrompt,
  globalVarPlaceholders,
  allAgents,
}) {
  return (
    <>
      {isSystemAgent && (
        <Box
          sx={{
            mb: 2.5,
            p: 1.5,
            borderRadius: "8px",
            backgroundColor: "action.hover",
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
            This is a system agent. Only the model can be changed.
          </Typography>
        </Box>
      )}

      <AgentConfigSection id="details">
        {!isSystemAgent && (
          <AgentAvatarField
            agentId={agentId}
            name={name}
            displayAvatarUrl={avatarDisplayUrl}
            canEditAvatar={canEditAvatar}
            uploadingAvatar={uploadingAvatar}
            avatarError={avatarError}
            onSelectFile={onSelectAvatarFile}
            onRemove={onRemoveAvatar}
            avatarAccept={avatarAccept}
          />
        )}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography className="org-field-label">Name</Typography>
            <TextField
              className="org-styled-textfield"
              fullWidth
              size="small"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="My Agent"
              disabled={isSystemAgent}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography className="org-field-label">Description</Typography>
            <TextField
              className="org-styled-textfield"
              fullWidth
              size="small"
              multiline
              minRows={2}
              maxRows={8}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="A brief description of what this agent does"
              disabled={isSystemAgent}
            />
          </Grid>
        </Grid>
      </AgentConfigSection>

      {!isSystemAgent && (
        <AgentConfigSection id="systemPrompt" sx={{ mt: 2.5 }}>
          <Typography className="org-field-label">System Prompt</Typography>
          <TipTapEditor
            value={systemPrompt}
            onChange={setSystemPrompt}
            placeholder="You are a helpful agent that..."
            markdown
            showToolbar={true}
            minHeight="200px"
            triggerChars={["$", "@"]}
            availablePlaceholders={globalVarPlaceholders}
            agentMentions={allAgents.map((a) => ({
              key: a.name,
              type: "agent",
              id: a.agentId,
              description: a.description,
            }))}
          />
          <Typography
            sx={{ fontSize: "11px", color: "text.disabled", mt: 0.5 }}
          >
            Instructions that define the agent&apos;s behavior. Type @ to
            reference other agents, $ for placeholders.
          </Typography>
        </AgentConfigSection>
      )}
    </>
  );
}
